import { render, staticRenderFns } from "./EnvironmentHero.vue?vue&type=template&id=27ff69bc&scoped=true&"
import script from "./EnvironmentHero.vue?vue&type=script&lang=js&"
export * from "./EnvironmentHero.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentHero.vue?vue&type=style&index=0&id=27ff69bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff69bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VParallax,VRow})
